//@ts-nocheck
import { useStore } from "@state/store"
import { filterTable, getFiltersDynamically } from "@lib/utils/residenceTableFn"
import { useEffect, useMemo, useState } from "react"
import { parseTSV } from "@data/parseTsv"

export type TFilters = {
  floor: number[]
  price: number[]
  beds: string[]
  topologies: string | null
}

export const useFilters = () => {
  const availabilityData = useStore((s) => s.availabilityData)

  const [initialFilters, setInitialFilters] = useState(null)

  const { syncState } = useStore((s) => ({
    syncState: s.syncState,
  }))

  const dynamicFilters = useMemo(() => {
    const dynamicFilters = getFiltersDynamically(availabilityData)

    return dynamicFilters
  }, [availabilityData])

  useEffect(() => {
    // console.log(dynamicFilters)
    syncState({
      filters: dynamicFilters,
    })
    setInitialFilters(dynamicFilters)
  }, [dynamicFilters, availabilityData])

  const filters = useStore((s) => s.filters)

  useEffect(() => {
    const filteredData = filterTable(filters, availabilityData)

    setTimeout(() => {
      syncState({
        filteredUnits: filteredData,
      })
    }, 250)
  }, [filters, availabilityData])

  const handleReset = () => {
    setTimeout(() => {
      syncState({
        filters: initialFilters,
      })
    }, 250)
  }

  const handleToggleChange = (
    key: keyof TFilters,
    value: any,
    onlyOneSelectable: boolean,
  ) => {
    const currentValues = filters[key] || []

    const updatedValues = onlyOneSelectable
      ? //@ts-ignore
        currentValues.includes(value)
        ? []
        : [value]
      : //@ts-ignore
      currentValues.includes(value)
      ? currentValues.filter((item) => item !== value)
      : [...currentValues, value]

    setTimeout(() => {
      syncState({
        filters: {
          ...filters,
          [key]: updatedValues,
        },
      })
    }, 250)
  }

  const handleRangeChange = (key: keyof TFilters, value: any) => {
    setTimeout(() => {
      syncState({
        filters: {
          ...filters,
          [key]: value,
        },
      }),
        250
    })
  }

  return {
    initialFilters,
    dynamicFilters,
    handleToggleChange,
    filters,
    handleRangeChange,
    handleReset,
  }
}
